// extracted by mini-css-extract-plugin
export default {"block":"Tl","flex":"Ul","radio":"Vl","label":"Wl","error":"Xl","extra":"Yl"};